// Added by Sejune Oh on 2019-03-19
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { Fragment } from 'react'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Define
import { ReactTablePagination, ReactInputChangeEvent } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Prime elements
import { TablePagination, TableRow } from '@/components/_primes'

// Components
import PaginationAction from './PaginationAction'
import { Theme, createStyles, withStyles, WithStyles } from '@material-ui/core'
import { LIGHT_GREY } from '@/styles/Theme'
import Intl from '@/helper/Intl'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
export interface TableFooterBaseFCProps {
    isPaginatable?: boolean
    count: number
    page: number
    rowsPerPage: number
    rowsPerPageOptions: Array<number>
    colSpan: number
    onPageChange: ReactTablePagination
    onRowsPerPageChange: ReactInputChangeEvent
    info?: string
}

interface TableFooterFCProps extends TableFooterBaseFCProps, WithStyles<typeof styles> { }

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const TableFooter = (props: TableFooterFCProps) => {
    const { isPaginatable, classes, colSpan, info, ...other } = props
    const colSpanSize = info ? colSpan / 2 : colSpan

    if (isPaginatable) {
        return (
            <TableRow>
                {info && (
                    <td className={classes.AdditionalInfoWrappr} colSpan={Math.ceil(colSpanSize)} data-cy-td={'additionalInfo'}>
                        {info}
                    </td>
                )}
                <TablePagination
                    {...other}
                    labelRowsPerPage={Intl.getIntlText({ id: 'htmljs_react.component.tablefooter.label_rows_per_page' })}
                    colSpan={Math.floor(colSpanSize)}
                    ActionsComponent={PaginationAction}
                />
            </TableRow>
        )
    }

    return <Fragment />
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const styles = (theme: Theme) =>
    createStyles({
        AdditionalInfoWrappr: {
            paddingLeft: `${theme.spacing()}px`,
            color: LIGHT_GREY,
        },
    })

export default withStyles(styles, { withTheme: true })(TableFooter)
